import { render, staticRenderFns } from "./selectGenderOnboarding.vue?vue&type=template&id=f231048c&scoped=true&"
import script from "./selectGenderOnboarding.vue?vue&type=script&lang=js&"
export * from "./selectGenderOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./selectGenderOnboarding.vue?vue&type=style&index=0&id=f231048c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f231048c",
  null
  
)

export default component.exports